import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  KeyRound,
  Settings,
  Link2,
  Smartphone,
  ExternalLink,
  ArrowRight,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const QUICK_STEPS = [
  {
    icon: KeyRound,
    color: "bg-purple-100 text-purple-700",
    title: "Pegue suas chaves",
    desc: "Acesse o painel do Mercado Pago e copie o Access Token e o Public Key.",
  },
  {
    icon: Settings,
    color: "bg-emerald-100 text-emerald-700",
    title: "Cole aqui no GGEE",
    desc: "Cole as chaves nos campos abaixo e clique em Salvar Configurações.",
  },
  {
    icon: Link2,
    color: "bg-indigo-100 text-indigo-700",
    title: "Gere um link",
    desc: "Vá em Mensalidades e clique em Gerar Link no aluno que vai pagar.",
  },
  {
    icon: Smartphone,
    color: "bg-sky-100 text-sky-700",
    title: "Envie pelo WhatsApp",
    desc: "Botão de WhatsApp abre mensagem pronta com o link. O aluno paga via PIX, Cartão ou Boleto.",
  },
];

export default function QuickStartPagamentoDialog({ open, onOpenChange }) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="quickstart-pagamento-dialog">
        <DialogHeader>
          <Badge className="bg-emerald-600 self-start mb-1">Início rápido</Badge>
          <DialogTitle className="text-2xl">
            Configurar pagamento em 4 passos
          </DialogTitle>
          <DialogDescription>
            Você cadastra uma vez e fica liberado para sempre. Depois é só
            gerar links e enviar para os pais.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 my-2">
          {QUICK_STEPS.map((step, idx) => (
            <div
              key={idx}
              className="flex items-start gap-3 p-3 rounded-lg border bg-gray-50"
              data-testid={`quickstart-step-${idx + 1}`}
            >
              <div
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${step.color} font-bold`}
              >
                {idx + 1}
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <step.icon className="w-4 h-4 text-gray-500" />
                  <span className="font-semibold text-sm">{step.title}</span>
                </div>
                <p className="text-xs text-gray-600 mt-1 leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <DialogFooter className="flex flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            onClick={() =>
              window.open(
                "https://www.mercadopago.com.br/developers/panel/app",
                "_blank"
              )
            }
            data-testid="quickstart-btn-painel-mp"
            className="w-full sm:w-auto"
          >
            <ExternalLink className="w-4 h-4 mr-2" />
            Abrir painel Mercado Pago
          </Button>
          <Button
            onClick={() => {
              onOpenChange(false);
              navigate("/ajuda/pagamentos");
            }}
            data-testid="quickstart-btn-manual-completo"
            className="bg-emerald-600 hover:bg-emerald-700 w-full sm:w-auto"
          >
            Ver manual completo
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
